// The languages a product's content is available in: several of the site's
// languages (the localization system's released ones), on aldoo-ra's
// DropdownSelect. The field stores their codes.
import React, { useEffect, useState } from "react"
import DropdownSelect from "aldoo-ra/DropdownSelect"
import { api } from "aldoo-ra/API"

const localizationAPI = api("localization")
let cached = null

export default function LanguagesField({ value, onChange }) {
  const [languages, setLanguages] = useState(cached || [])
  useEffect(() => {
    if (cached) return
    let alive = true
    localizationAPI({ languages: true })
      .then((res) => {
        // the released languages (the api answers the list, or { languages })
        const list = (Array.isArray(res) ? res : res?.languages || []).filter((l) => l?.code && l.release !== false)
        cached = list
        if (alive) setLanguages(list)
      })
      .catch(() => {})
    return () => {
      alive = false
    }
  }, [])
  const options = languages.map((l) => ({ value: l.code, name: l.displayName || l.name || l.code }))
  const codes = Array.isArray(value) ? value : []
  const selected = codes.map((code) => options.find((o) => o.value === code) || { value: code, name: code })
  return (
    <DropdownSelect
      variant="admin"
      options={options}
      value={selected}
      multiSelection
      showItemNamesInSelection
      showSelectAll={false}
      placeholder="Languages"
      onChange={(picked) => onChange?.((Array.isArray(picked) ? picked : [picked]).filter(Boolean).map((p) => p.value))}
    />
  )
}
